<div class="container">
  <div class="list-section">
    @for (item of data.items; track item) {
      <div class="row line-item">
        <span><strong>{{item.key}}: </strong>{{item.value}}</span>
      </div>
    }
  </div>
</div>
